<template>
  <div class="confirmation">    
    <div class="appointment-info">     
      <div class="appointment">
        <h2>Booking submitted</h2>
        <div class="message">{{ response.message }}</div>
        <div class="date" v-html="response.date" />
        <div class="primary" v-html="response.primary" />        
        <Button
          text="Book another Appointment"
          link=""        
          class="book"
          @click="$emit('resetBooking')"
        />        
      </div>
      <img src="@/assets/images/confirmation.jpg" alt="">
    </div>
  </div>
</template>

<script>
//can close the iframe from the child only because it is same origin
//frameElement.parentNode.removeChild(frameElement)
import Button from "@/components/AOButton";
export default {
  name: "Confirmation",
  components: {
    Button,
  },
  props: {
    response:Object
  },
  data() {
    return {
      /*`   
      response: {
        message: "Richard, you have successfully booked an appointment!",
        date: "June 24, 2022 &bull; 8:30 am",
        primary:
          "<p class='full-name'>Test F Tesxt L (test d)</p> <p class='email'>richard@channel1media.com</p> <p class='phone'>6546546565</p> <p class='company'>Company</p> <p class='address'>65 Address</p> <p class='notes'>ntoes</p>",
        guests:
          "<p class='guest'>Gf Gl(richard@channel1media.com)</p><p class='guest'>Gf Gl(richard@channel1media.com)</p>",
      },
      /* */
    };
  },
};
</script>

<style lang="scss" scoped>
.book {
    border:none;
  margin-top:1rem;
}
.confirmation {
  flex-direction: column;
  color: var(--ao-black);    
  border-radius: 6px;
  font-size: 1rem;
  overflow:hidden;
  box-shadow: 0px 4px 35px rgba(0, 0, 0, 0.16) !important;  
  > div {
    font-size:1rem;        
  }
}

.date {  
  font-size: 2rem;
  padding: 20px 0;
  text-transform: uppercase;
}
h3 {
  margin-bottom: 0;
  color: var(--green);
}
.primary {
  :deep() {
    p {
      margin: 8px 0;
      font-size: 1rem;
    }
  }
}
.guest-info {
  :deep() {
    .guest {
      font-size: 1rem;
      margin: 4px 0;
      &:first-child {
        margin-top: 1em;
      }
    }
  }
}
.appointment-info {
  display: flex;
  font-size: 1.25rem;
  flex-direction: column;  
  position: relative;
   img {
    display:none;
    position: absolute;
    right:0;
    top:0;
    height:100%;
    width:300px;
    object-fit:  cover;
  }
  @media (min-width: 1100px) {
    flex-direction: row;
    img {
        display: inline-block;
    }
  }
 
  > div {
    padding: 15px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .left {
    max-width:280px;
  }
  .appointment {    
    padding: 75px 50px;
    align-items: flex-start;
    position: relative;
    text-align: left;
  }
}

svg {
  fill: var(--white);
  width: 130px;
}
h2 {
  color:var(--black);
  text-align: left;
  padding: 10px 0;
  margin: 0;
  font-size:2rem;  
  text-transform: uppercase;
}
</style>